export const SIDEBAR_NAV_ROUTE_DATA = {
    WORKSPACE: 'workspace',
    WORKSPACE_BY_TYPE: 'workspaceByType',
    PROJECT_BY_CONTAINER_TYPE: 'projectByContainerType',
    DB_BY_CONTAINER_TYPE: 'dbByContainerType',
    COMMUNITY_PROJECTS: 'communityprojects',
    PROFILE: 'profile',
    ADMIN: 'admin',
    ORGANIZATION: 'organization',
} as const;

/**
 * Union of all allowed `sidebarNav` route-data values.
 *
 * How this works:
 * - `as const` keeps object values as string literals (not widened to `string`).
 * - `typeof SIDEBAR_NAV_ROUTE_DATA` gets the object type.
 * - `keyof ...` gets all object keys (e.g. `WORKSPACE`, `PROFILE`).
 * - `T[K]` (indexed access type) returns the value types for these keys.
 *
 * Result example:
 * `'workspace' | 'workspaceByType' | 'projectByContainerType' | ...`
 */
export type SidebarNavRouteData =
    (typeof SIDEBAR_NAV_ROUTE_DATA)[keyof typeof SIDEBAR_NAV_ROUTE_DATA];
